<template>
  <div id="interview-change">
    <div class="bread">
      <router-link class="bread-item" to="/">上上签</router-link>
      <div class="bread-arrow">&gt;</div>
      <span class="bread-item" @click="$router.go(-1)">订单详情</span>
      <template v-if="$route.name === 'reOrderPay'">
        <div class="bread-arrow">&gt;</div>
        <span class="bread-item">重新预约缴费</span>
      </template>
    </div>

    <div class="cue-container">
        <div class="cue-container-label">
          <img class="icon" src="https://o.666visa.cn/static/ssqpeer/common/icon_embassy.png" alt="">
          <div class="text">赴馆信息</div>
        </div>
        <div class="cue">
          <div class="cue-item">请选择3个方便前往使馆的时间；<span class="mark">注意：所选时间为优先预约时间</span>，若无法预约，签证专家将联系您重新确认。</div>
          <div class="cue-item">预约成功后，如需修改赴馆时间，需补缴 <span class="mark">{{getUpdateDatePrice}}元/人/次</span> 重新预约。</div>
          <div v-if="earlistDateData && earlistDateData.interview_notice" class="cue-item">{{earlistDateData.interview_notice}}</div>
        </div>
      </div>
    <div class="interview-date-select-form" v-if="dataModel && fullHoliday">
      <interview-date-select-form
        :order="dataModel"
        v-if="earlistDateData"
        v-model="interviewformData"
        :holiday="fullHoliday"
        :earlist-date="earlistDateData"
        :error="interviewFormDataErrorMap"
        :cityDateEmpty="cityDateEmpty"
        @switchInterviewTogether="switchInterviewTogether" />
      <!-- <div class="button-area">
        <el-button type="primary" class="common-button" @click="onChangeSubmit">确认修改</el-button>
      </div> -->
    </div>

    <div class="pay-container" v-if="order">
      <interview-change-pay ref="interviewChangePay" @pay="pay()" @refuseUpdateDate="refuseUpdateDate" :apply_by="order.apply_by" :balance="peer.balance_amount" :price="getUpdateDatePrice" :count="applicantIdsToChange.length"></interview-change-pay>
    </div>

    <!-- 余额不足 -->
    <insufficient-balance-modal
      v-model="rechargeDialog"
      :order-id="orderId"
      :from="'interviewChange'"
      :chargePrice="this.getUpdateDatePrice * this.applicantIdsToChange.length * 100 - peer.balance_amount"
      :from-param="{ oid: orderId }"
      :from-query="pageQuery"
    ></insufficient-balance-modal>
  </div>
</template>

<script>
import User from '@/libs/user';
// import { mapState } from 'vuex';
import interviewMixin from '../mixins/interview';
import utils from '../libs/utils';
import Http from '../libs/http';
import interviewDateSelectForm from '../components/interview-date-select-form.vue';
import interviewChangePay from '../components/order-detail/interview-change-pay.vue';
import orderingService from '../services/ordering-service';
import orderComfirmService from '../services/order-comfirm-service';
import insufficientBalanceModal from './ordering/modals/insufficient-balance-modal';

export default {
  data() {
    return {
      orderId: +this.$route.params.oid,
      pageQuery: this.$route.query,
      holiday: [],
      fullHoliday: [],
      interviewformData: null,
      interviewSubmitted: false,
      order: null,
      interviewFormDataErrorMap: [],
      earlistDateData: null,
      peer: { balance_amount: 0 }, // 同业用户信息
      rechargeDialog: false, // 账户余额不足模态框
    };
  },
  components: {
    interviewDateSelectForm,
    interviewChangePay,
    insufficientBalanceModal,
  },
  computed: {
    // ...mapState("order/", {
    //   applicantIdsToChange: "applicantIdsToChange"
    // }),
    applicantIdsToChange() {
      return JSON.parse(this.$route.query.aidArray);
    },
    dataModel() {
      if (!this.order) return null;
      const res = utils.extend({}, this.order);
      const { applicant } = this.order;

      /* eslint-disable camelcase */
      res.applicant = applicant.filter(
        ({ order_applicant_id }) =>
          this.applicantIdsToChange.indexOf(order_applicant_id) > -1,
      );
      return res;
    },
    // 获取每次修改赴馆时间价格
    getUpdateDatePrice() {
      return this.earlistDateData
        ? this.earlistDateData.interview_change_fee / 100
        : 0;
    },
    // 获取一同赴馆时的最早赴馆时间，接口返回所有申请人最早赴馆时间，需获取选中申请人并进行比较
    getEarlistDateTo() {
      return this.earlistDateData.applicant
      // 获取当前选中申请人
        .filter(item => this.applicantIdsToChange.indexOf(item.order_applicant_id) > -1)
        // 获取申请人最早赴馆时间
        .map(item => new Date(item.earliest_date))
        // 对事件数组进行升序排序，获取第一个便是最早赴馆时间
        .sort((a, b) => (a < b ? 1 : -1))[0];
    },
  },
  methods: {
    onChangeSubmit() {
      this.interviewSubmitted = true;
      const valid = this.validateInterviewDate();
      if (valid) {
        utils.msgbox
          .confirm(
            '使馆预约操作复杂，若预约成功后需要修改，可能耽误您的办理进度。确定所选日期范围内能够准时前往使馆？',
            '温馨提示',
            {
              confirmButtonText: '确定',
              cancelButtonText: '再想想',
              type: 'warning',
            },
          )
          .then(() => {
            this.trimFormData();
            return Http.post(
              '/order_interview_time_change',
              this.interviewformData,
            );
          })
          .then(() => {
            this.$router.go(-1);
          })
          .catch((e) => {
            if (e) console.log(e);
          });
      } else {
        return utils.msg.warning('请完善赴馆日期信息');
      }
    },
    // 获取订单信息
    getOrder() {
      return Http.post('/order_query', {
        user_order_id: +this.$route.params.oid,
      }).then((res) => {
        this.order = res;
      }).catch((e) => {
        if (e) console.log(e);
      });
    },
    // 获取国家信息
    getCountryHoliday() {
      const self = this;
      return Http.post('/sys/visa_country_holiday_date_query', {
        visa_country_id: self.order.visa_country_id,
      }).then((res2) => {
        this.holidays = res2[self.order.visa_country_id];
        this.handleHolidayArr();
        // 判断当前路由是重新预约缴费or修改赴馆时间
        if (this.$route.name === 'reOrderPay' || this.$route.name === 'interviewChange') {
          // 初始化信息并获取重新预约缴费用户选择的赴馆时间
          this.switchInterviewChangeTab();
        } else {
          // 修改赴馆时间初始化信息并默认展示申请人预约相同时间标签页
          this.switchInterviewTogether(1);
        }
      }).catch((e) => {
        if (e) console.log(e);
      });
    },
    // 获取最早赴馆时间信息
    getEarlistDateData() {
      return orderingService.getEarlistDateData(this.orderId).then((data) => {
        this.earlistDateData = data;
      }).catch((e) => {
        if (e) console.log(e);
      });
    },
    // 拒绝顾客修改赴馆时间
    refuseUpdateDate() {
      utils.msgbox
        .confirm('确定要拒绝顾客的修改赴馆时间请求？', '重要提示', {
          confirmButtonText: '确定',
          cancelButtonText: '再想想',
          type: 'warning',
        }).then(() =>
          // 检测用户修改赴馆申请是否已支付
          Http.post('/order_interview_time_change_check', {
            user_order_id: this.orderId,
            applicants: JSON.parse(this.$route.query.aidArray),
          }).then((res) => {
            if (Object.keys(res).length) {
              const applicants = res.result.map(item => item.applicant_name).join('、');
              const type = this.$route.name === 'reOrderPay' ? '重新预约' : '修改赴馆时间';
              utils.msgbox.alert(
                `${applicants}的${type}费用已经缴纳,无法拒绝`,
                '出错了',
                {
                  confirmButtonText: '知道了',
                  callback: () => {
                    this.$router.replace({ name: 'orderDetail', params: { oid: this.orderId } });
                  },
                },
              );
              return Promise.reject('订单已支付');
            }
          }),
        )
        .then(() => Http.post('/order_interview_time_change_refuse', {
          user_order_id: this.orderId,
          applicants: JSON.parse(this.$route.query.aidArray),
        }).then((res) => {
          if (res.msg === '重新预约申请已拒绝') {
            utils.msg.success('重新预约申请已拒绝');
            this.$router.push({ name: 'orderDetail', params: { oid: this.orderId } });
            return Promise.reject('订单已拒绝');
          }
        }))
        .then(() => {
          utils.msg.success('重新预约申请已拒绝，顾客将收到短信提醒');
          this.$router.push({ name: 'orderDetail', params: { oid: this.orderId } });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 重新预约缴费/修改赴馆时间 支付
    pay() {
      // 刷新余额信息，防止多端操作
      this.getPeer().then(async () => {

        // 如果是金棕榈订单，校验后直接跳转到金棕榈支付页面
        // 判断余额是否大于订单支付金额 (如果是金棕榈订单，不需要比较，其它校验后直接跳转到支付页面)
        if (User.is_palmyou || (this.peer.balance_amount / 100 >= this.getUpdateDatePrice * this.applicantIdsToChange.length)) {
          this.interviewSubmitted = true;
          const valid = this.validateInterviewDate();
          // 验证填入的赴馆时间
          if (valid) {
            // 验证赴馆时间是否过期
            const interviewDateIsOutdated = this._checkInterviewDateIsOutDated();
            if (!interviewDateIsOutdated) {
              await this.checkInterviewDate();
              utils.msgbox
                .confirm(
                  `确认提交订单并支付金额￥${this.getUpdateDatePrice * 100 * this.applicantIdsToChange.length / 100}？`,
                  '温馨提示',
                  {
                    confirmButtonText: '确定',
                    cancelButtonText: '再想想',
                    type: 'warning',
                  },
                )
                .then(() =>
                // 检测用户修改赴馆申请是否已支付
                  Http.post('/order_interview_time_change_check', {
                    user_order_id: this.orderId,
                    applicants: JSON.parse(this.$route.query.aidArray),
                  }).then((res) => {
                    if (Object.keys(res).length) {
                      const applicants = res.result.map(item => item.applicant_name).join('、');
                      const type = this.$route.name === 'reOrderPay' ? '重新预约' : '修改赴馆时间';

                      utils.msgbox.alert(
                        `${applicants}的${type}费用已经缴纳,无法支付`,
                        '出错了',
                        {
                          confirmButtonText: '知道了',
                          callback: () => {
                            this.$router.replace({ name: 'orderDetail', params: { oid: this.orderId } });
                          },
                        },
                      );
                      return Promise.reject('订单已支付');
                    }
                  }),
                )
                .then(() => {
                  this.trimFormData();
                  // 修改赴馆时间
                  return Http.post(
                    '/order_interview_time_change',
                    this.interviewformData,
                  );
                })
                .then(() => {
                  // 修改时间成功后吊起支付（金棕榈渠道不需要调用这个接口）
                  if (!User.is_palmyou) {
                    return Http.post('/order_interview_time_change_pay', {
                      user_order_id: this.orderId,
                      applicants: JSON.parse(this.$route.query.aidArray),
                    });
                  }
                })
                .then(() => {

                  // 金棕榈订单，跳转到金棕榈支付页面
                  if (User.is_palmyou) {
                    this.$router.replace({
                      name: 'payConfirm',
                      params: {
                        oid: this.orderId,
                      },
                      query: {
                        typeid: 2,
                        payPrice: this.getUpdateDatePrice * 100 * this.applicantIdsToChange.length / 100,
                        applicants: this.$route.query.aidArray,
                      },
                    });
                    return;
                  }

                  // 支付成功后跳转至付款成功页面
                  this.$router.push({
                    name: 'interviewChangePaySuc',
                    params: { oid: this.orderId },
                  });
                })
                .catch((err) => {
                  console.log(err);
                });
            }
          } else {
            return utils.msg.warning('请完善赴馆日期信息');
          }
        } else {
          this.rechargeDialog = true;
        }
      });
    },
    // 数据初始化
    initData() {
      this.getPeer();
      this.getOrder()
        .then(() => this.getCountryHoliday())
        .then(() => this.getEarlistDateData())
        .catch((e) => {
          if (e) console.log(e);
        });
    },
    // 获取同业信息
    getPeer() {
      return orderComfirmService.peerQuery().then((data) => {
        this.peer = data;
      }).catch((e) => {
        if (e) console.log(e);
      });
    },
    // 校验赴馆日期是否晚于出行日期
    async checkInterviewDate() {
      let error = false;
      this.interviewformData.data.forEach((interviewItem) => {
        if (interviewItem.date_choice !== 0) return;

        if (interviewItem.preferred_date.some(item => item.date > this.dataModel.depart_date)) {
          error = true;
        }
      });
      if (error) {
        await utils.msgbox
          .confirm(
            '当前指定赴馆日期存在晚于期望出行日期，确定进行提交吗？',
            '提示',
            {
              confirmButtonText: '确定',
              cancelButtonText: '再想想',
              type: 'warning',
            },
          );

      }
    },
  },
  mixins: [interviewMixin],
  created() {
    this.initData();
  },
};
</script>

<style lang="less" scoped>
@import '../assets/less/variable.less';
#interview-change {
  width: 920px;
  margin: auto;
  padding-bottom: 100px;
}

.cue-container {
  padding:30px  30px 16px;
  background: #ffffff;
  .cue-container-label{
    display: flex;
    justify-content: flex-start;
    gap: 8px;
    .icon{
      display: block;
      width: 16px;
      height: 16px;
    }
    .text{
      font-weight: 400;
      font-size: 16px;
      color: #2F333D;
    }
  }
  .cue {
      color: #8F99A0;
      font-size: 12px;
      padding-left: 25px;
      margin-top: 16px;
      
      .mark {
        color: #ff5a60;
      }
      .cue-item {
        position: relative;
        padding-left: 12px;
        
        &::before {
          content: "";
          position: absolute;
          left: 0;
          top: 50%;
          transform: translateY(-50%);
          width: 4px;
          height: 4px;
          background-color: #8F99A0;
          border-radius: 50%;
        }
        
        & + .cue-item {
          margin-top: 8px;
        }
      }
    }

}

span.bread-item {
  cursor: pointer;
}

  .button-area {
    text-align: center;
    margin-top: 32px;
  }

  .interview-date-select-form {
    padding: 1px 40px 40px 50px;
    background-color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/pages/InterviewChange.vue